import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateFormat'
})

export class DatePipe implements PipeTransform {
    transform(value: any): string {
        if (!value) {
            return '';
        }

        const months = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];

        const str = value.toString().trim();

        // Try to parse "dd-MM-yyyy ..." or "dd/MM/yyyy ..." format
        const match = str.match(/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})/);
        if (match) {
            const day = match[1].padStart(2, '0');
            const monthIndex = parseInt(match[2], 10) - 1;
            const year = match[3];

            if (monthIndex >= 0 && monthIndex < 12) {
                return `${day} ${months[monthIndex]} ${year}`;
            }
        }

        // Fallback: try new Date() for other formats (ISO, etc.)
        const date = new Date(str);
        if (!isNaN(date.getTime())) {
            const day = date.getDate().toString().padStart(2, '0');
            const month = months[date.getMonth()];
            const year = date.getFullYear();
            return `${day} ${month} ${year}`;
        }

        return value;
    }
}



// WEBPACK FOOTER //
// ./src/filters/dateFormat.pipe.ts